import React from "react";
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import "./Navbar.css";

const NavBar = () => {
  return (
    <div className="sticky-top">
      <Navbar
        bg="black"
        data-bs-theme="dark"
        className="navigation-bar"
        collapseOnSelect
        expand="lg"
      >
        <Container>
          <Navbar.Brand>
            <NavLink to="/home" className="navbar-title">
              <h2 className="nav-head">Arifur Rahman</h2>
            </NavLink>
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav "
            className="toggle"
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="mx-auto">
              <NavLink
                className="nav-items fs-6 px-3  py-2 fw-bold "
                to="/home"
              >
                Home
              </NavLink>
              <NavLink
                className="nav-items fs-6 px-3  py-2 fw-bold "
                to="/aboutmedetails"
              >
                About me
              </NavLink>
              <NavLink
                className="nav-items fs-6 px-3  py-2 fw-bold "
                to="/blogs"
              >
                My Blogs
              </NavLink>
              <NavLink className="nav-items fs-6 px-3  py-2 fw-bold " to="/">
                Contact Me
              </NavLink>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default NavBar;
